<template>
    <div>

        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item>
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getStopRecordListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary"  @click="getStopRecordListHandler">搜索查询</el-button>
                <el-button type="success" @click="getStopRecordListHandler">刷新</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="confirmExportDialogVisible = true">导出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="iccid" label="ICCID"></el-table-column>
            <el-table-column prop="intoNo" label="接入号"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"></el-table-column>
            <el-table-column label="总流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalRateFlow) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.totalUsedFlow) }}
                </template>
            </el-table-column>
            <el-table-column prop="stateName" label="平台卡状态"></el-table-column>
            <el-table-column prop="supplierSimStatus" label="运营商卡状态"></el-table-column>
            <el-table-column prop="typeName" label="操作类型"></el-table-column>
            <el-table-column prop="createTime" label="停机时间"></el-table-column>
            <el-table-column prop="failReason" label="失败原因"></el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportStopRecordListHandler">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getStopRecordList,exportPollingStopInfo} from '@/api/csm.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            confirmExportDialogVisible:false//导出确认框
        }
    },
    methods: {
        getStopRecordListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getStopRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getStopRecordListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getStopRecordListHandler();
        },
        exportStopRecordListHandler(){
            let _that = this;

            exportPollingStopInfo(_that.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去下载专区下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));         
        }    
    },
    created(){
        this.getStopRecordListHandler();
    }
}
</script>